import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Cloud, CloudOff } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Shows the attach controls only when the user's Google Drive is connected.
const DriveAttachGate = ({ children }) => {
  const { tWithFallback } = useLanguage();
  const [conn, setConn] = useState(undefined);

  useEffect(() => {
    let alive = true;
    axios.get(`${API}/cloud/connections`, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } })
      .then((res) => alive && setConn((res.data?.connections || []).find((c) => c.provider === 'google') || null))
      .catch(() => alive && setConn(null));
    return () => { alive = false; };
  }, []);

  if (conn === undefined) return <div className="h-16 rounded-lg bg-gray-50 animate-pulse" data-testid="drive-gate-loading" />;

  if (!conn || conn.reauth_required) {
    return (
      <div className="rounded-lg border border-amber-200 bg-amber-50 p-4 flex items-start gap-3" data-testid="drive-gate-connect">
        <CloudOff className="w-5 h-5 text-amber-600 shrink-0 mt-0.5" />
        <div className="flex-1 text-sm text-amber-900">
          <p className="font-medium">
            {conn ? tWithFallback('driveReconnectTitle', 'Reconnect Google Drive to attach files') : tWithFallback('driveConnectTitle', 'Connect Google Drive to attach files')}
          </p>
          <p className="text-xs mt-1 text-amber-800">{tWithFallback('driveConnectHint', 'Files are saved in your own Google Drive, never on our servers.')}</p>
        </div>
        <a href="/settings/cloud" data-testid="drive-gate-connect-btn" className="shrink-0 text-sm font-medium px-3 py-1.5 rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition-colors">
          {tWithFallback('connectBtn', 'Connect')}
        </a>
      </div>
    );
  }

  return (
    <div data-testid="drive-gate-ready">
      <p className="flex items-center gap-1.5 text-xs text-gray-500 mb-2" data-testid="drive-gate-account">
        <Cloud className="w-3.5 h-3.5 text-blue-500" />
        {tWithFallback('driveSavedTo', 'Saved to your Google Drive')}{conn.account_email ? ` · ${conn.account_email}` : ''}
      </p>
      {children}
    </div>
  );
};

export default DriveAttachGate;
